import { render } from "./Cart.vue?vue&type=template&id=2cc4f451"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"

import "./Cart.vue?vue&type=style&index=0&id=2cc4f451&lang=less"

import exportComponent from "E:\\vue-prj\\newbee-mall-vue3-app-main\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__